import { useAppSelector } from '../../app/hooks'
import { fetchLoggedInUserSelector } from '../selectors'
import { ILoggedInUser } from '../types'
import AssetForm from './AssetForm'

const CreateAsset = () => {
  const { tenantId } = useAppSelector(fetchLoggedInUserSelector.data) || ({} as ILoggedInUser)
  const newAsset = {
    tenantId,
    transportModeId: 0,
    assetCategoryId: 0,
    detail: {
      isOwned: true,
    },
    documents: [],
    physicalProperties: {
      useDimensions: true,
      isRectangular: true,
      internalUseDimensions: true,
      externalUseDimensions: true,
      internalIsRectangular: true,
      externalIsRectangular: true,
    },
    active: true,
  }
  return <AssetForm asset={newAsset} />
}

export default CreateAsset
